<template>
  <div class="feed-card feed__message-block">
    <div class="d-flex position-relative">
      <span class="v-line"></span>
      <span class="circle-step flex-shrink-0"></span>

      <div class="content">
        <h3 v-html="userActivity.title_html"></h3>

        <GoogleMap
          :api-key="googleMapFrontApiKey"
          style="width: 100%; height: 300px"
          :center="{ lat: parseFloat(userActivity.data.current_latitude), lng: parseFloat(userActivity.data.current_longitude) }"
          :zoom="15"
          :disable-default-ui="true"
        >
          <CustomMarker
            :options="{ position: beneficaryGeolocation }"
          >
            <BeneficiaryMapIcon class="beneficiary-marker" />
          </CustomMarker>

          <CustomMarker
            :options="{ position: { lat: parseFloat(userActivity.data.current_latitude), lng: parseFloat(userActivity.data.current_longitude) } }"
          >
            <DriverAvatar :missionInfos="missionInfos" />
          </CustomMarker>

          <Polyline :options="driverPath" />
        </GoogleMap>


        <TimeInfos :userActivity="userActivity"/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { GoogleMap, CustomMarker, Polyline } from 'vue3-google-map'
  import TimeInfos from '@components/utils/TimeInfos.vue';
  import BeneficiaryMapIcon from '@images/BeneficiaryMapIcon.vue';
  import {computed} from "vue"
  import DriverAvatar from '@components/utils/DriverAvatar.vue';
  import { googleMapFrontApiKey } from "@lib/utilities"

  const props = defineProps({
    userActivity: Object,
    beneficaryGeolocation: Object,
    missionInfos: {
      type: Object,
      default: () => null
    }
  });

  const driverPath = computed(() => {
    return {
      path: props.userActivity.data.path_coordinates.map((coordinate) => {
        return { lat: coordinate.latitude, lng: coordinate.longitude }
      }),
      strokeColor: '#FF0000',
      strokeWeight: 3
    }
  })
</script>

<style scoped>
  .logo {
    width: 5Opx;
    height: 50px;
    border-radius: 100%;
  }
</style>